import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import SupplementList from 'containers/SupplementList'
import Phaser from 'components/Phaser'
import { RootMeta } from 'components/Meta'
import PageDescription from 'components/supplements/PageDescription'

const styles = (theme) => ({
  container: {
    padding: 20,
  },
  header: {
    border: '1px solid red',
  },
  body: {},
  goButton: {
    background: theme.palette.primary.main,
    color: '#fff',
    position: 'absolute',
    right: 10,
    bottom: -8,
  },
  pageDescriptionLargerDevices: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
})

const WeightLossSupplementsPage = ({ classes, data }) => {
  const {
    site: { siteMetadata },
    markdownRemark,
  } = data

  return (
    <div>
      <RootMeta
        url={siteMetadata.siteUrl + '/weight-loss-supplements'}
        title={`Supplements For Weight Loss | ${siteMetadata.siteName}`}
        description="Supplements That Promote Weight Loss"
        breadCrumb={[]}
      />
      <Grid classes={{ container: classes.container }} spacing={24} container>
        <Grid xs={12} item>
          <Phaser label="Supplements for Weight Loss" />
        </Grid>
        <Grid xs={12} item>
          <PageDescription pageDescription={markdownRemark.html} />
          <Typography
            className={classes.pageDescriptionLargerDevices}
            dangerouslySetInnerHTML={{ __html: markdownRemark.html }}
          />
        </Grid>
        <Grid xs={12} item>
          <Typography variant="headline">
            Sold on{' '}
            <span style={{ color: '#ff9900', fontWeight: 700 }}>Amazon</span>
          </Typography>
        </Grid>
        <Grid classes={{ item: classes.body }} xs={12} item>
          <Grid spacing={16} container>
            <SupplementList />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
} //

WeightLossSupplementsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query SupplementsPageQuery {
    site {
      siteMetadata {
        siteUrl
        siteName
        siteDescription
      }
    }
    # prettier-ignore
    markdownRemark(frontmatter: { title: { eq: "Supplements" } }) {
      html
      timeToRead
      frontmatter {
        title
      }
    }
  }
`

export default withStyles(styles)(WeightLossSupplementsPage)



// WEBPACK FOOTER //
// ./src/pages/weight-loss-supplements.js